import axios from "axios";
import React, { useState, useEffect } from "react";
import host from "../host";
import "./Offer.css";
import Spinner from "../Spinner";

function Offer(props) {
  const [offeredSubject, setOfferedSubject] = useState([]);
  const [loadingOffer, setLoadingOffer] = useState(true);
  const [selectedTrim, setSelectedTrim] = useState(0);

  const student = props.student;
  const trimesters = props.trimesters;

  // Initial fetch runs once; subsequent loads follow selected trimester changes.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadOffered();
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    loadOffered();
  }, [selectedTrim]);

  const loadOffered = () => {
    setLoadingOffer(true);
    axios
      .post(`${host}loadOfferedSubjects`, {
        idstudent: student.idstudent,
        idsyc: selectedTrim,
      })
      .then((res) => {
        setOfferedSubject(res.data);
        setLoadingOffer(false);
      });
  };

  const renderSlots = (slot) => {
    if (slot === 0) {
      return (
        <div>
          Open Slots:{" "}
          <span style={{ color: "red", fontWeight: "bold" }}>{slot}</span>
        </div>
      );
    } else {
      return (
        <div>
          Open Slots:{" "}
          <span style={{ color: "green", fontWeight: "bold" }}>{slot}</span>
        </div>
      );
    }
  };

  const renderOffered = () => {
    if (offeredSubject.length === 0) {
      return <div>There are no subjects offered for you right now</div>;
    } else {
      return (
        <div className="subjectsGrid">
          {offeredSubject.map((val, key) => {
            return (
              <div
                className={`subject bg-white ${
                  val.iscompleted ? "bg-neutral-300" : ""
                }`}
                key={key}
              >
                <div className="subjectName">{`${val.subject_name}${
                  val.iscompleted ? " (Completed)" : " "
                }`}</div>
                <div>Section: {val.class_name}</div>
                <div className="subjectDescription">{val.description}</div>
                {renderSlots(val.slot - val.enrolledCount)}
                <div>
                  Instructor:{" "}
                  <span style={{ fontWeight: "bold" }}>{val.instructor}</span>
                </div>
                <div>Room: {val.roomname}</div>
                <div>Schedule: {val.schedule}</div>
              </div>
            );
          })}
        </div>
      );
    }
  };

  return (
    <React.Fragment>
      <div className="offerTitle">
        <h1>Offered Subjects</h1>
      </div>

      <div className="subjectsOffered">
        <div className="selectTrimester">
          <select
            className="peaci-select w-full max-w-md"
            onChange={(e) => {
              setSelectedTrim(e.target.value);
              console.log(e.target.value);
            }}
            value={selectedTrim}
          >
            <option value="0">Select Trimester</option>
            {trimesters.map((val, key) => {
              return (
                <option value={val.idsyc} key={key}>
                  {val.sy_name}
                </option>
              );
            })}
          </select>
        </div>
        {loadingOffer ? <Spinner /> : renderOffered()}
      </div>
    </React.Fragment>
  );
}

export default Offer;
